module.exports = __webpack_public_path__ + "media/packs/images/notification/price-f4bea3c05fd3b3310c99492174118982.svg";